import { Grid, TextField } from "@mui/material"
import { Paper } from "@mui/material"
import { ptBR } from "@mui/x-date-pickers/locales"
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from 'dayjs';
import { Control, Controller } from "react-hook-form"
import { IFormStatePrograma } from "src/servicos/IFormularios"

export interface IProgramaTimecode{
    idProgramaTimecode?: string
    versao?: string
    dataHora? : string
    duracao ?: string
    resposta : string
    texto : string
    autor ?: string
    status ? : string
    isMenorLGView ?: boolean
    ind: number
    Ccontrol: Control<IFormStatePrograma, any>
}

const TimecodeView = (props: IProgramaTimecode) =>
{
    return <>
        <Paper
            variant={props.isMenorLGView ? 'outlined' : 'elevation'}
            elevation={props.isMenorLGView ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'lg'
            sx={{ mb:2, padding:(props.isMenorLGView ? 2 : 0), paddingBottom:(props.isMenorLGView ? 2 : 4) }}
        >
            <Grid container spacing={1} alignItems={"center"}>
                <Grid item xs={12} sm={3} lg={3}>
                    <Controller
                        name={`programaTimecodes.${props.ind}.versao`}
                        control={props.Ccontrol}
                        render={({ field }) => (
                            <TextField
                                label="Versão"
                                fullWidth
                                value={field.value || ''}
                                size="small"
                                inputProps={{
                                    readOnly: true // Impede a edição manual
                                }}
                                // sx={styletimecodesInputs}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
                        <Controller
                            name={`programaTimecodes.${props.ind}.dataHora`}
                            control={props.Ccontrol}
                            render={({ field }) => (
                                <DateTimePicker
                                    {...field}
                                    readOnly={true}
                                    // value={dayjs.utc(props.formDefaultValues.dataAlerta ? props.formDefaultValues.dataAlerta : dayjs(new Date())) as unknown as string}
                                    value={ field.value ? dayjs.utc(field.value ? field.value : '') as unknown as string : null }
                                    label="Data"
                                    ampm={false}
                                    // defaultValue={field.value ? dayjs.utc(field.value ? field.value : '') as unknown as string : null}
                                    timezone="America/Sao_Paulo"
                                    format="DD-MM-YYYY H:mm"
                                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                />
                            )}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                    <Controller
                        name={`programaTimecodes.${props.ind}.timecode`}
                        control={props.Ccontrol}
                        render={({ field }) => (
                            <TextField
                                label="Duração"
                                inputProps={{
                                    readOnly: true // Impede a edição manual
                                }}
                                fullWidth
                                value={field.value || ''}
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                    <Controller
                        name={`programaTimecodes.${props.ind}.status`}
                        control={props.Ccontrol}
                        render={({ field }) => (
                            <TextField
                                label="Status"
                                inputProps={{
                                    readOnly: true, // Impede a edição manual
                                }}
                                fullWidth
                                value={field.value || ''}
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={3} lg={12}>
                    <Controller
                        name={`programaTimecodes.${props.ind}.resposta`}
                        control={props.Ccontrol}
                        render={({ field }) => (
                            <TextField
                                label="Resposta"
                                inputProps={{
                                    readOnly: true // Impede a edição manual
                                }}
                                multiline
                                minRows={2}
                                maxRows={5}
                                fullWidth
                                value={field.value || ''}
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={6} lg={12}>
                    <Controller
                        name={`programaTimecodes.${props.ind}.texto`}
                        control={props.Ccontrol}
                        defaultValue=""
                        render={({ field }) => (
                            <TextField
                                label="Texto"
                                inputProps={{
                                    readOnly: true // Impede a edição manual
                                }}
                                multiline
                                minRows={2}
                                maxRows={5}
                                fullWidth
                                value={field.value || ''}
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={3} lg={12}>
                    <Controller
                        name={`programaTimecodes.${props.ind}.autor`}
                        control={props.Ccontrol}
                        render={({ field }) => (
                            <TextField
                                label="Autor"
                                inputProps={{
                                    readOnly: true // Impede a edição manual
                                }}
                                multiline
                                minRows={1}
                                maxRows={5}
                                fullWidth
                                value={field.value || ''}
                                size="small"
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </Paper>
    </>
}

export default TimecodeView;